<div class="filter-container">
  <div class="filter-header">
    <div class="filter-title mt-1">
      {{ tableFilter().title }}
    </div>
    <lib-button [type]="ButtonType.tertiary" [size]="InputSize.small" (buttonClick)="resetClicked()" i18n>
      Reset
    </lib-button>
  </div>
  <div class="mt-3 d-flex flex-column gap-3">
    <lib-checkbox [size]="InputSize.small" [selected]="useRange()" (checkboxClick)="rangeCheckboxClicked()" i18n>
      Range
    </lib-checkbox>
    @if (!useRange()) {
      <div>
        <label class="form-input-label mb-1" [for]="exactDateFormControlId" i18n>Date</label>
        <lib-date-input [formControl]="exactDateFormControl" [controlId]="exactDateFormControlId"> </lib-date-input>
      </div>
    } @else {
      <div>
        <label class="form-input-label mb-1" [for]="minDateFormControlId" i18n>From Date</label>
        <lib-date-input
          [maxDate]="minDateRange()"
          [formControl]="minDateFormControl"
          [controlId]="minDateFormControlId">
        </lib-date-input>
      </div>
      <div>
        <label class="form-input-label mb-1" [for]="maxDateFormControlId" i18n>To Date</label>
        <lib-date-input
          [minDate]="maxDateRange()"
          [formControl]="maxDateFormControl"
          [controlId]="maxDateFormControlId">
        </lib-date-input>
      </div>
    }
  </div>
</div>
